export enum BuildMode {
  Development = "development",
  Beta = "beta",
  Production = "production",
}
